module.exports = __webpack_public_path__ + "img/04-full.983c2906.jpeg";